var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled, { css, keyframes } from 'styled-components';
var DEFAULT_SIZE = 40; // Default control size (px)
var DEFAULT_COLOR = "white"; // Default control color
var AnimatedLoaderBase = /** @class */ (function (_super) {
    __extends(AnimatedLoaderBase, _super);
    function AnimatedLoaderBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () {
            var p = _this.props;
            return (React.createElement("div", { className: p.className },
                React.createElement(Svg, { width: "1792", height: "1792", viewBox: "0 0 1792 1792", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M1760 896q0 176-68.5 336t-184 275.5-275.5 184-336 68.5-336-68.5-275.5-184-184-275.5-68.5-336q0-213 97-398.5t265-305.5 374-151v228q-221 45-366.5 221t-145.5 406q0 130 51 248.5t136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5q0-230-145.5-406t-366.5-221v-228q206 31 374 151t265 305.5 97 398.5z" }))));
        };
        return _this;
    }
    return AnimatedLoaderBase;
}(React.Component));
var rotate = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n"], ["\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n"])));
var fade = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% { opacity: 1 }\n  50% { opacity: 0.2 }\n  100% { opacity: 1 }\n"], ["\n  0% { opacity: 1 }\n  50% { opacity: 0.2 }\n  100% { opacity: 1 }\n"])));
var Svg = styled('svg')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  animation: ", " 2s linear infinite, ", " 3s linear infinite;\n"], ["\n  width: 100%;\n  height: 100%;\n  animation: ", " 2s linear infinite, ", " 3s linear infinite;\n"
    /**
     * Shows an animated Loading component when the active prop is true.
     */
])), rotate, fade);
/**
 * Shows an animated Loading component when the active prop is true.
 */
var AnimatedLoaderstyled = styled(AnimatedLoaderBase)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  /* Position */\n  position: absolute;\n  z-index: 100;\n  ", "\n  ", "\n  ", "\n  ", "  \n\n  max-width: 200px;\n  max-height: 200px;\n  width: ", "px;\n  height: ", "px;\n\n  opacity: 0;\n  cursor: grab;\n  pointer-events: none;\n  user-select: none;\n  transition: opacity ease-in-out 150ms;\n  opacity: ", ";\n  ", " {\n    fill: ", ";\n  }\n"], ["\n  /* Position */\n  position: absolute;\n  z-index: 100;\n  ", "\n  ", "\n  ", "\n  ", "  \n\n  max-width: 200px;\n  max-height: 200px;\n  width: ", "px;\n  height: ", "px;\n\n  opacity: 0;\n  cursor: grab;\n  pointer-events: none;\n  user-select: none;\n  transition: opacity ease-in-out 150ms;\n  opacity: ", ";\n  ", " {\n    fill: ", ";\n  }\n"
    /**
     * A loading animation, to be shown when the map is loading. Captures no
     * pointer events. Use the `active` prop to show and hide the animation.
     * This shows a rotating notched-circle SVG.
     *
     * @example
     * ```tsx
     * <AnimatedLoader x={-50} y={50} active color="green"/>
     * ```
     */
])), function (p) { return p.x >= 0 && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["left:   ", "px;"], ["left:   ", "px;"])), p.x); }, function (p) { return p.x < 0 && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["right:  ", "px;"], ["right:  ", "px;"])), -p.x); }, function (p) { return p.y >= 0 && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["top:    ", "px;"], ["top:    ", "px;"])), p.y); }, function (p) { return p.y < 0 && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["bottom: ", "px;"], ["bottom: ", "px;"])), -p.y); }, function (p) { var _a; return (_a = p.size) !== null && _a !== void 0 ? _a : DEFAULT_SIZE; }, function (p) { var _a; return (_a = p.size) !== null && _a !== void 0 ? _a : DEFAULT_SIZE; }, function (p) { return p.active ? 1 : 0; }, Svg, function (p) { var _a; return (_a = p.color) !== null && _a !== void 0 ? _a : DEFAULT_COLOR; });
/**
 * A loading animation, to be shown when the map is loading. Captures no
 * pointer events. Use the `active` prop to show and hide the animation.
 * This shows a rotating notched-circle SVG.
 *
 * @example
 * ```tsx
 * <AnimatedLoader x={-50} y={50} active color="green"/>
 * ```
 */
var AnimatedLoader = function (p) { return React.createElement(AnimatedLoaderstyled, __assign({}, p)); };
export { AnimatedLoader };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
